import { useLayoutEffect, useRef } from 'react';
import Lenis from '@studio-freight/lenis';

const LenisProvider = () => {
  const lenisRef = useRef(null);
  useLayoutEffect(() => {
    lenisRef.current = new Lenis({ duration: 0.8, smoothWheel: true });
    const animate = (time) => {
      lenisRef.current.raf(time);
      requestAnimationFrame(animate);
    };
    const id = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(id);
      lenisRef.current?.destroy();
    };
  }, []);
  return null; // This component doesn't render any UI.
};

export default LenisProvider;
